import { CommonStore, AuthStore, CustomersStore, CustomerOrdersStore, Report1Store, Report2Store, Report3Store, AcceptancesStore, PrintStore, SearchHistoryStore, OrdersNotificationStore, CdekStore, VinQueriesStore } from './';
import { RouterStore } from 'mobx-react-router';
import { configure } from 'mobx';
import { NotificationStore } from './NotificationStore';
import { CreateEditCustomerOrderStore } from './Sales/CreateEditStore';
import { RejectionsStore } from './RejectionsStore';
import { DemandsStore } from './DemandsStore';
import { KassesStore } from './KassesStore';
import { UsersStore } from './UsersStore';

configure({ enforceActions: "observed" });

export class RootStore {

    commonStore: CommonStore;
    routingStore: RouterStore;
    authStore: AuthStore;
    notificationStore: NotificationStore;
    createEditCustomerOrderStore: CreateEditCustomerOrderStore;
    customerOrdersStore: CustomerOrdersStore;
    customersStore: CustomersStore;
    rejectionsStore: RejectionsStore;
    report1Store: Report1Store;
    report2Store: Report2Store;
    report3Store: Report3Store;
    demandsStore: DemandsStore;
    acceptancesStore: AcceptancesStore;
    printStore: PrintStore;
    searchHistoryStore: SearchHistoryStore;
    kassesStore: KassesStore;
    ordersNotificationStore: OrdersNotificationStore;
    cdekStore: CdekStore;
    usersStore: UsersStore;
    vinQueriesStore: VinQueriesStore;

    constructor(notificationStore: NotificationStore, localStorage: Storage, document: Document, window: Window) {

        this.commonStore = new CommonStore(this, window);
        this.routingStore = new RouterStore();
        this.authStore = new AuthStore(this);
        this.createEditCustomerOrderStore = new CreateEditCustomerOrderStore(this);
        this.customersStore = new CustomersStore(this);
        this.customerOrdersStore = new CustomerOrdersStore(this);
        this.rejectionsStore = new RejectionsStore(this);
        this.report1Store = new Report1Store(this);
        this.report2Store = new Report2Store(this);
        this.report3Store = new Report3Store(this);
        this.demandsStore = new DemandsStore(this);
        this.acceptancesStore = new AcceptancesStore(this);
        this.printStore = new PrintStore(this);
        this.searchHistoryStore = new SearchHistoryStore(this);
        this.searchHistoryStore = new SearchHistoryStore(this);
        this.kassesStore = new KassesStore(this);
        this.cdekStore = new CdekStore(this);
        this.vinQueriesStore = new VinQueriesStore(this);
        this.usersStore = new UsersStore(this);
        this.ordersNotificationStore = new OrdersNotificationStore(this, localStorage, document);


        this.notificationStore = notificationStore;

        setTimeout(() => {
            this.rejectionsStore.loadNewRejectionsCount();
        }, 1000);

        setInterval(() => {
            this.rejectionsStore.loadNewRejectionsCount();
        }, 1000 * 60);

        setTimeout(() => {
            this.customerOrdersStore.loadUnacceptedOrdersCount();
        }, 1000);

        setInterval(() => {
            this.customerOrdersStore.loadUnacceptedOrdersCount();
        }, 1000 * 60);

        setTimeout(() => {
            this.vinQueriesStore.loadUnreadedVinQueryCount();
        }, 1000);

        setInterval(() => {
            this.vinQueriesStore.loadUnreadedVinQueryCount();
        }, 1000 * 60);
    }
}